import { Box, Stack, Typography } from '@dtx-company/design-system/src'
import { ChevronRight } from '@mui/icons-material'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

interface PlanTileCopyProps {
  header: string
  subheader: string
}
export const PlanTileCopy: React.FC<PlanTileCopyProps> = ({ header, subheader }) => {
  const { t } = useTranslation('nav')
  return (
    <Stack direction="column" sx={{ minWidth: { xs: '50%', sm: 'auto' } }}>
      <Stack direction="row">
        <Typography variant="subtitleSmall">{t(header)}</Typography>
        <Spacer mr="4px" />
        <ChevronRight />
      </Stack>
      <Spacer mb="8px" />
      <Box
        sx={theme => ({
          color: 'onSurface.secondary',
          '.MuiTypography-root': { lineHeight: theme.spacing(5) }
        })}
      >
        <Typography variant="bodySmall" color="inherit">
          {t(subheader)}
        </Typography>
      </Box>
    </Stack>
  )
}
